<template>
  <div class="pwd-notice-top-main">
    <p><span class="mr-10"><i class="el-icon-info"></i></span><span class="important mr-10">{{$t('pdwComplexity.important')}}</span><span v-html="$t('pdwComplexity.topTips')"></span></p>
  </div>
</template>

<script>
export default {
  props: {
   
  },
  methods: {
    
  }
};
</script>

<style>
  .pwd-notice-top-main{
    position: absolute;
    background: white;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    padding: 10px 20px;
    width: max-content;
    font-size: 18px;
    border-radius: 5px;
    color: #909399;
  }
  .pwd-notice-top-main .el-icon-info{
      color: rgb(24, 68, 225);
  }
  .pwd-notice-top-main .important,.important{
      color: rgb(24, 68, 225);
  }
</style>
